<template>
  <div
    v-clickout
    class="drop-downA"
    :class="{ selecting: selecting }"
    @clickout="selecting = false"
    @click="
      selecting = !selecting
      clickStat('XZYXAN', '选择游戏按钮')
    "
  >
    <input v-if="inputable" type="text" class="drop-down-sel" />
    <div v-else class="drop-down-sel ellipsis-1">
      {{ curTxt }}
    </div>
    <div v-if="list.length" class="drop-downA-list">
      <div class="drop-downA-list-scorll">
        <p
          v-for="(item, i) in list"
          :key="item.id"
          @click.stop="
            change(item, i)
            clickStat(`XZYX${i + 1}`, `选择游戏${i + 1}`)
          "
        >
          <a href="javascript:;" class="ellipsis-1">{{ item[labelKey] }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { clickout } from '~/plugins/vue-clickout'
export default {
  directives: {
    clickout
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    labelKey: {
      type: String,
      default: 'title'
    },
    inputable: {
      type: Boolean,
      default: false
    },
    defIndex: {
      type: [Number, String],
      default: -1
    },
    statParams: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      selecting: false,
      curIndex: +this.defIndex
    }
  },
  computed: {
    curTxt() {
      return this.curItem[this.labelKey] || this.placeholder
    },
    curItem() {
      return this.list[this.curIndex] || {}
    }
  },
  watch: {
    list() {
      this.curIndex = +this.defIndex
    },
    defIndex(val) {
      this.curIndex = +val
    }
  },
  methods: {
    change(item, index) {
      this.selecting = false
      this.curIndex = index
      this.$emit('change', index, item)
    },
    setIndex(index) {
      this.curIndex = index
    },
    clickStat(eid, eid_desc) {
      if (!this.statParams) {
        return
      }
      this.$util.clickStat(
        `${this.statParams.eid}/${eid}`,
        `${this.statParams.eid_desc}/${eid_desc}`
      )
    }
  }
}
</script>
